export const MIXED_FEED_STORAGE_KEY = 'mackinac:mixedFeed'

/** Shape stored in localStorage under MIXED_FEED_STORAGE_KEY (new format) */
export interface MixedFeedState {
    enabled: boolean
    /** null = "all pinned feeds"; string[] = explicit per-feed selection */
    feeds: string[] | null
}

/** Parse any stored value — legacy strings, new URI arrays, and new object shape — into MixedFeedState */
export function parseMixedFeedStorage(stored: string | null): MixedFeedState {
    if (stored === null) return { enabled: false, feeds: null }
    if (stored === 'true') return { enabled: true, feeds: null }
    if (stored === 'false') return { enabled: false, feeds: null }
    try {
        const parsed = JSON.parse(stored)
        // New object shape: { enabled, feeds }
        if (parsed !== null && typeof parsed === 'object' && !Array.isArray(parsed)) {
            return {
                enabled: Boolean(parsed.enabled),
                feeds: Array.isArray(parsed.feeds) ? (parsed.feeds as string[]) : null,
            }
        }
        // Legacy from this branch: a bare URI array → enabled=true
        if (Array.isArray(parsed)) {
            return { enabled: true, feeds: parsed as string[] }
        }
    } catch {
        /* ignore */
    }
    return { enabled: false, feeds: null }
}

export function writeMixedFeedStorage(state: MixedFeedState) {
    try {
        const value = JSON.stringify(state)
        localStorage.setItem(MIXED_FEED_STORAGE_KEY, value)
        // Native storage events only fire in other tabs; dispatch synthetic so same-tab
        // listeners (e.g. Home) can react immediately.
        window.dispatchEvent(
            new StorageEvent('storage', {
                key: MIXED_FEED_STORAGE_KEY,
                newValue: value,
                storageArea: localStorage,
            })
        )
    } catch {
        /* localStorage unavailable */
    }
}
